// components

// react
import { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";

// kendo
import kendo from "@progress/kendo-ui";

// css
import './notiLog_mobile.css';
import styles from './notiLog_mobile.module.css';

// services

function NotiLogItemMobile({conn, item}) {

  const history = useHistory();

  // 대상자 정보 이동
  const cid = item.cid;
  const userId = item.userId;
  const goUserInfo = () => {
    // history.push({
    //   pathname: "/user/info",
    //   state: { cid, userId }
    // });
    history.push({
      pathname: "/notiLogDetail",
      state: { cid, userId }
    })
  }

  // 위험발생 타입
  const dangerType = () => {
    if (item.eventType === 11001) {
      return "긴급버튼";
    } else if (item.eventType === 11002) {
      return "음성인식";
    } else if (item.eventType === 11003) {
      return "위험전환"
    } else if (item.eventType === 11004) {
      return "안심존 입장"
    } else if (item.eventType === 11005) {
      return "안심존 퇴장"
    } else if (item.eventType === 11006) {
      return "장비 미작동"
    }
  }

  // 대상자 통화
  const callUser = () => {
    return document.location.href='tel:' + item.userPhone;
  }


  useEffect(() => {
  },[])

  return (
    <>
     <div className={styles.notiItem} onClick={goUserInfo}>
     <div className={styles.leftDiv}>
          <div className={styles.messageDiv}>
            <p className={styles.userTermText}>{item.userTerm}님&nbsp;&nbsp;</p>
            <p className={styles.dangerTypeText}>{dangerType()}&nbsp;</p>
            <p className={styles.basicText}>알림</p>
          </div>
          <p className={styles.dateText}>{kendo.toString(new Date(item.sentDtm), 'yyyy년 MM월 dd일 HH시 mm분')}</p>
        </div>
        <div className={styles.rightDiv}>
          <img className={styles.callImg} src="/images/mobile/call2_btn.png" onClick={callUser}></img>
        </div>
     </div>
    </>
  );
}

export default NotiLogItemMobile;
